import React from 'react'
import {graphql} from 'gatsby'

import Layout from '../../components/Layout'
import ConferenceExpositionSection from '../../components/ConferenceExpositionSection'

import IntroSection from './components/IntroSection'
import AboutGoalsSection from './components/AboutGoalsSection'
import EventsSection from '../../components/EventsSection'
import CoursesNewsletterSection from './components/CoursesNewsletterSection'
import NewsSection from './components/NewsSection'

const IndexPage = ({data: dataObj}) => {
	const data = dataObj.index.childPagesJson.childPagesJsonWithRelativePaths
	return <Layout seo={{routeUrl: '/', ...data.seo}}>
		<IntroSection data={data.intro}/>
		<ConferenceExpositionSection/>
		<AboutGoalsSection data={data.aboutGoals}/>
		<EventsSection data={data.events}/>
		<CoursesNewsletterSection data={data.coursesNewsletter}/>
		<NewsSection data={data.news}/>
	</Layout>
}


export default IndexPage

export const query = graphql`
{
	index: file(relativePath: {eq: "pages/indexPage.json"}) {
    childPagesJson {
      childPagesJsonWithRelativePaths {
      	intro {
      		aboveTitle
      		title
      		belowTitle
      		leftButton {
				label
				link
      		}
      		rightButton {
      			label
      			link
      		}
      	}
      	
      	aboutGoals {
      		title
      		text
      		goals {
      			title
      			items {
      				text
      			}
      		}
      		join {
      			title
      			button {
      				label
      				link
      			}
      		}
      	}
      	
      	events {
      		title
      		bullets {
      			text
      		}
      		text
      		button {
      			label
      			link
      		}
      	}
      	
      	coursesNewsletter {
      		courses {
      			title
      			text
      			button {
      				label
      				link
      			}
      		}
      	}
      	
      	news {
      		title
      		button {
      			label
      			link
      		}
      	}
      	
        seo {
        	title
          description
          author
          metaImage {
            publicURL
          }
        }
      }
    }
  }
}
`
